"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeletePaymentRequest = exports.useCreatePaymentRequest = exports.usePaymentMethodsRequest = void 0;

var _tslib = require("tslib");

var _useRequest = _interopRequireDefault(require("../useRequest/useRequest"));

var _utility = require("../api/utility");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var transactionId = (0, _utility.getTransactionId)();
var addedHeaders = {
  'X-Transaction-ID': transactionId
};

var usePaymentMethodsRequest = function usePaymentMethodsRequest(parameters, isAsync, isAuthenticated) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  if (isAuthenticated === void 0) {
    isAuthenticated = false;
  }

  if (!isAuthenticated) {
    return {
      data: undefined,
      isLoading: false,
      isErrored: false,
      exception: undefined
    };
  }

  return (0, _useRequest["default"])({
    method: 'get',
    path: 'paymentMethods',
    params: (0, _tslib.__assign)({}, parameters),
    headers: addedHeaders
  }, isAsync);
};

exports.usePaymentMethodsRequest = usePaymentMethodsRequest;

var useCreatePaymentRequest = function useCreatePaymentRequest(parameters, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'post',
    path: 'paymentMethods',
    params: (0, _tslib.__assign)({}, parameters),
    headers: addedHeaders
  }, isAsync);
};

exports.useCreatePaymentRequest = useCreatePaymentRequest;

var useDeletePaymentRequest = function useDeletePaymentRequest(parameters, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'delete',
    path: 'paymentMethods',
    params: (0, _tslib.__assign)({}, parameters),
    headers: addedHeaders
  }, isAsync);
};

exports.useDeletePaymentRequest = useDeletePaymentRequest;